type DispatchFn = (eventName: string, properties: Record<string, unknown>) => void;
type GetBasePropertiesFn = () => Record<string, unknown>;

type EventTrackerConfig = {
  dispatch: DispatchFn;
  getBaseProperties?: GetBasePropertiesFn;
};

type EventTracker = {
  track: (eventName: string, specificProperties?: Record<string, unknown>) => void;
  trackWithBase: (
    eventName: string,
    baseProperties: Record<string, unknown>,
    specificProperties?: Record<string, unknown>
  ) => void;
  dispatch: DispatchFn;
  getBaseProperties: GetBasePropertiesFn;
};

const createEventTracker = (config: EventTrackerConfig): EventTracker => {
  const { dispatch, getBaseProperties = () => ({}) } = config;

  const track = (eventName: string, specificProperties: Record<string, unknown> = {}): void => {
    dispatch(eventName, { ...getBaseProperties(), ...specificProperties });
  };

  const trackWithBase = (
    eventName: string,
    baseProperties: Record<string, unknown>,
    specificProperties: Record<string, unknown> = {}
  ): void => {
    dispatch(eventName, { ...baseProperties, ...specificProperties });
  };

  return { track, trackWithBase, dispatch, getBaseProperties };
};

export { createEventTracker };
export type { EventTrackerConfig, EventTracker, DispatchFn, GetBasePropertiesFn };
